var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Page.css';
import Loading from '../Loading/Loading';
import PageMessage from './Support/PageMessage/PageMessage';
export default function Page(_a) {
    var className = _a.className, children = _a.children, loading = _a.loading, error = _a.error, message = _a.message;
    if (error) {
        return (_jsx("div", __assign({ className: className + ' Page flexCenter full error' }, { children: error }), void 0));
    }
    if (loading) {
        return (_jsx("div", __assign({ className: className + ' Page flexCenter full' }, { children: _jsx(Loading, {}, void 0) }), void 0));
    }
    return (_jsxs("div", __assign({ className: className + ' Page' }, { children: [_jsx(PageMessage, { message: message }, void 0), children] }), void 0));
}
//# sourceMappingURL=Page.js.map